<div [ngClass]="isCheckISO ? 'contentMiniClass' : ''">
  <div class="row table-div">
    <p *ngIf="isCheckISO" class="content-name-subtitle uniqTableSeq">
      Table #1: {{ reportResource.lblImpactCategoriesDefinition }}
    </p>
    <div class="table-content">
      <table class="table">
        <thead>
          <tr>
            <td style="width: 20%">{{ isCheckISO ? 'Indicator' : reportResource.lblCategory }}</td>
            <td style="width: 10%">{{ isCheckISO ? 'Unit' : reportResource.lblOnlyIndicator }}</td>
            <td style="width: 70%">
              {{ isCheckISO ? 'Underlying characterization model' : reportResource.lblDescription }}
            </td>
          </tr>
        </thead>

        <tbody *ngIf="!isCheckISO; else checkIsoBlock">
          <tr>
            <td>{{ reportResource.lblClimateChange }}</td>
            <td>kg Co<sub>2</sub>eq</td>
            <td>{{ reportResource.climateDescription }}</td>
          </tr>
          <tr>
            <td>{{ reportResource.lblOzoneDepletion }}</td>
            <td>kg CFC-11 eq</td>
            <td>{{ reportResource.OzoneDepletionDescription }}</td>
          </tr>
          <tr>
            <td>{{ reportResource.lblHumanToxicityCancerEffects }}</td>
            <td>CTUh</td>
            <td>{{ reportResource.HumanToxicityCancerDescription }}</td>
          </tr>
          <tr>
            <td>{{ reportResource.lblHumanToxicityNonCancer }}</td>
            <td>CTUh</td>
            <td>{{ reportResource.HumanToxicityNonCancerDescription }}</td>
          </tr>
          <tr>
            <td>{{ reportResource.lblParticulateMatter }}</td>
            <td>Measured in g PM2.5</td>
            <td>{{ reportResource.ParticulateMatterDescription }}</td>
          </tr>
          <tr>
            <td>{{ reportResource.lblIonisingRadiationHH }}</td>
            <td>kBq U235 eq</td>
            <td>{{ reportResource.IonisingRadiationDescription }}</td>
          </tr>
          <tr>
            <td>{{ reportResource.lblPhotochemicalOzoneFormation }}</td>
            <td>kg C<sub>2</sub> H<sub>4</sub> eq</td>
            <td>{{ reportResource.PhotochemicalOzoneDescription }}</td>
          </tr>
          <tr>
            <td>{{ reportResource.lblAcidification }}</td>
            <td>mol H+ eq</td>
            <td>{{ reportResource.AcidificationDescription }}</td>
          </tr>
          <tr>
            <td>{{ reportResource.lblEutrophicationTerrestrial }}</td>
            <td>mol N eq</td>
            <td>{{ reportResource.EutrophicationTerrestrialDescription }}</td>
          </tr>
          <tr>
            <td>{{ reportResource.lblEutrophicationFreshWater }}</td>
            <td>kg PO4 3- eq</td>
            <td>{{ reportResource.EutrophicationFreshWaterDescription }}</td>
          </tr>
          <tr>
            <td>{{ reportResource.lblEutrophicationMarine }}</td>
            <td>kg N eq</td>
            <td>{{ reportResource.EutrophicationMarineDescription }}</td>
          </tr>
          <tr>
            <td class="caption">
              {{ reportResource.lblEcotoxicityFreshWater }}
            </td>
            <td>CTUe</td>
            <td>{{ reportResource.EcotoxicityFreshWaterDescription }}</td>
          </tr>
          <tr>
            <td class="caption">{{ reportResource.lblLandUseImpact }}</td>
            <td>kg C deficit</td>
            <td>{{ reportResource.LandUseImpactDescription }}</td>
          </tr>
          <tr>
            <td class="caption">{{ reportResource.lblLandOccupation }}</td>
            <td>ha year</td>
            <td>{{ reportResource.LandOccupationDescription }}</td>
          </tr>
          <tr>
            <td class="caption">
              {{ reportResource.lblResourceDepletionWater }}
            </td>
            <td>M3 water eq.</td>
            <td>{{ reportResource.ResourceDepletionWaterDescription }}</td>
          </tr>
          <tr>
            <td class="caption">{{ reportResource.lblWaterUseVolume }}</td>
            <td>kL H2O</td>
            <td>{{ reportResource.WaterUseVolumeDescription }}</td>
          </tr>
          <tr>
            <td class="caption">{{ reportResource.lblAbiotic }}</td>
            <td>Kg Sb eq</td>
            <td>
              {{ reportResource.AbioticDepletionMineralFossilDescription }}
            </td>
          </tr>
          <tr>
            <td class="caption">{{ reportResource.lblResourceDamage }}</td>
            <td>$ surplus cost</td>
            <td>{{ reportResource.ResourceDamageMineralFossilDescription }}</td>
          </tr>
          <tr>
            <td class="caption">
              {{ reportResource.lblCumulativeEnergyDemand }}
            </td>
            <td>MJ LHV</td>
            <td>{{ reportResource.CumulativeEnergyDemandDescription }}</td>
          </tr>
          <tr>
            <td class="caption">{{ reportResource.lblSolidWaste }}</td>
            <td>Kg</td>
            <td>{{ reportResource.SolidWasteDescription }}</td>
          </tr>
        </tbody>
        <ng-template #checkIsoBlock>
          <tbody>
            <tr *ngFor="let item of indicatorList">
              <ng-container>
                <td>{{ item.name }}</td>
                <td>{{ item.unit }}</td>
                <td>{{ item.underlyingCharacterizationModel }}</td>
              </ng-container>
            </tr>
          </tbody>
        </ng-template>
      </table>
    </div>
  </div>
</div>
